import { ChangeDetectorRef, HostListener, OnInit, ViewChild } from "@angular/core"
import { Component } from "@angular/core"
import { Router } from "@angular/router"
import { Subscription } from "rxjs"
import { MapMarker } from "src/app/models/marker"
import { BuildingReq, PopReq } from "src/app/models/requests"
import { MapService } from "src/app/services/map.service"
import { ico_civic_picked, ico_pop_naz } from "src/configs/map_configuration"
import { pageConfiguration } from "src/configs/page_configuration"
import { environment } from "src/environments/environment"
import { SearchPlaceComponent } from "../../shared/address/search-place/search-place.component"
import { GMapComponent } from "../../shared/map/gmap/gmap.component"

@Component({
	selector: "app-network-coverage",
	templateUrl: "./network-coverage.component.html",
	styleUrls: ["./network-coverage.component.scss"]
})
export class NetworkCoverageComponent implements OnInit {
	public point = null
	public isValidPoint = false
	public errorCoverage = false
	public pop: any
	public popList: any[] = []
	public popsAutocompleteList: any[] = []
	public markersPops: MapMarker[] = []
	public markersPcn: MapMarker[] = []
	public markersPopAgf: MapMarker[] = []
	public markersPois: MapMarker[] = []
	public cachedCivics: any[] = []
	public newCivics: any[] = []
	public typesMarkersPointsNTW = ["POINT_CIVIC", "POINT_PICKED", "PICKED", "POINT_PLACE"]
	public popsObjList = {}
	public networkLines = []
	public networkData: any
	public networkNationalData: any
	public searchBuildingPlaceholdersSubscription: Subscription
	public geocoder = new google.maps.Geocoder()
	public wait = false
	public waitCivics = false
	public modalBuildings = []
	public actualSearchMode
	private request: any
	private place: any = null
	private isPlaceSelected = false
	public isPointRequested = false
	private olocode: string
	public setOptions: string[] = []

	public assets_version = environment.ASSETS_VERSION
	public configuration = pageConfiguration
	public mapOptions: any
	private ZOOM_CLUSTER = 10
	private clearTypes: string[] = ["cluster", "FTTH", "FTTH C&D", "FWA C&D", "MAN", "AGF"]

	@ViewChild("searchPlace", { static: true }) searchPlace: SearchPlaceComponent
	@ViewChild("map", { static: true }) map: GMapComponent

	@HostListener("window:message", ["$event"])
	onMessage(e) {
		console.log("MESSAGE: ", e)
		this.sendMapReady(e)
	}

	sendMapReady(e) {
		if (e && e.data && e.data.for === "openfiber_map") {
			this.mapOptions = e.data.of_data
			this.mapService.lang = this.mapOptions.language ? this.mapOptions.language.toLowerCase() : "it"
			this.mapService.useLanguage(this.mapService.lang.toLowerCase())
			this.olocode = this.mapOptions.olo_code ? this.mapOptions.olo_code : null
			const payloadName = this.mapOptions.service_name + "_" + this.mapOptions.cluster
			this.mapService.activePayload = payloadName
			this.mapService.searchModes = pageConfiguration[payloadName].searchModes
			this.mapService.mapButtons.pops.active = pageConfiguration[payloadName].pops
			this.mapService.mapButtons.covered_ab.active = pageConfiguration[payloadName].covered_ab
			this.mapService.mapButtons.covered_cd.active = pageConfiguration[payloadName].covered_cd
			this.mapService.mapButtons.covered_agf.active = pageConfiguration[payloadName].covered_agf
			this.mapService.mapButtons.pops.visible = pageConfiguration[payloadName].buttons.includes("pop")
			this.mapService.mapButtons.pcn.visible = pageConfiguration[payloadName].buttons.includes("pcn")
			this.mapService.mapButtons.pop_agf.visible = pageConfiguration[payloadName].buttons.includes("pop_agf")
			this.mapService.mapButtons.pop_all.visible = pageConfiguration[payloadName].buttons.includes("pop_all")
			this.setOptionsLabel(pageConfiguration[payloadName])
			console.log("EMIT MAP READY", e.data)
			setTimeout(() => {
				this.mapService.mapReadyEvent.emit(true)
			}, 1000)
		}
	}

	public onMapReady() {
		this.populateMapDefault()
	}

  public update() {
    this.setMapButton('pops');
    this.setMapButton('pcn');
    this.setMapButton('pop_agf');
    this.setMapButton('pop_all');
    this.setMapButton('poi');
    this.manageBuildingsAndClusters(this.mapService.selectedCluster, this.mapOptions.service_name);
  }

	public onMarkerClicked(marker) {
		this.isPointRequested = true
		this.map.removeMarkersByTypes(this.typesMarkersPointsNTW)
		const type = marker.type.split(" ")[0]
		switch (type) {
			case "POP":
				this.onSelectPop(marker)
				break
			case "PCN":
				this.onSelectPop(marker)
				break
			case "POP_AGF":
				this.onSelectPop(marker)
				break
			case "cluster":
				this.onClickCluster(marker)
				break
			case "FTTH":
			case "FWA":
			case "MAN":
			case "AGF": {
				this.onSelectCivic(marker)
				this.mapService.open("loaderModal")
				break
			}
		}
	}

	public onClickMapButton(type) {
		this.mapService.mapButtons[type].active = !this.mapService.mapButtons[type].active
		this.setMapButton(type)
	}

	constructor(
		public mapService: MapService,
		private router: Router,
		 private _changeRef: ChangeDetectorRef
	) {}

	ngOnInit() {
		if (environment.LOCAL) {
			this.initMapInLocalEnv()
		} else {
			this.checkIfMapReady()
		}
		if (this.router.url === "/marketing/home") {
			window.location.replace(`/home`)
		}
	}

	initMapInLocalEnv() {
		setTimeout(() => {
			const payloadName = "open_stream_cd" // available names can be found as keys in page_configuration.ts
			this.mapOptions = {}
			this.mapOptions.language = "IT"
			this.mapService.lang = this.mapOptions.language.toLowerCase()
			this.mapService.useLanguage(this.mapService.lang.toLowerCase())
			this.mapOptions.service_name = "open_stream" // comes from payloadName
			this.mapOptions.cluster = "cd" // comes from payloadName
			this.mapService.activePayload = payloadName
			this.mapService.searchModes = pageConfiguration[payloadName].searchModes // can be found in page_configuration.ts
			this.mapService.mapButtons.pops.active = pageConfiguration[payloadName].pops // can be found in page_configuration.ts
			this.mapService.mapButtons.covered_ab.active = pageConfiguration[payloadName].covered_ab // can be found in page_configuration.ts
			this.mapService.mapButtons.covered_cd.active = pageConfiguration[payloadName].covered_cd // can be found in page_configuration.ts
			this.mapService.mapButtons.covered_agf.active = pageConfiguration[payloadName].covered_agf // can be found in page_configuration.ts
			this.mapService.mapButtons.pops.visible = pageConfiguration[payloadName].buttons.includes("pop") // depends on pop
			this.mapService.mapButtons.pcn.visible = pageConfiguration[payloadName].buttons.includes("pcn") // depends on pcn
			this.mapService.mapButtons.pop_agf.visible = pageConfiguration[payloadName].buttons.includes("pop_agf") // depends on pop_agf
			this.mapService.mapButtons.pop_all.visible = pageConfiguration[payloadName].buttons.includes("pop_all") // triggers pop/pcn/pop_agf all together
			this.mapService.mapReadyEvent.emit(true) // to send a postmessage
			this.actualSearchMode = "address" // default search method. can be found in page_configuration.ts
			this.setOptionsLabel(pageConfiguration[payloadName])
		}, 2000)
	}

	checkIfMapReady() {
		this.mapService.mapReadyEvent.subscribe(ready => {
			if (ready) {
				this.actualSearchMode = this.mapService.searchModes[0].value
			}
		})
	}

	private setOptionsLabel(data: any): void {
		if (data["covered_ab"]) {
			this.setOptions.push("A&B")
		}
		if (data["covered_cd"]) {
			this.setOptions.push("C&D")
		}
		if (data["covered_agf"]) {
			this.setOptions.push("BI1G")
		}
	}

	public populateMapDefault() {
		if (this.mapService.mapButtons.pops.active) {
			this.getPops(this.configuration[this.mapService.activePayload])
		}
	}

	private getPops(config) {
		this.mapService.getPops(this.olocode).subscribe(res => {
			this.popList = res
			this.markersPops = []
			this.markersPcn = []
			this.markersPopAgf = []
			for (const pop of res) {
				if (config.covered_ab) {
					if (pop.type !== "Secondary" && pop.type !== "AGF") {
						this.markersPops.push(
							this.mapService.popToMarker(pop, config.icons.pop_standard, config.icons.pop_smaller)
						)
					}
				}
				if (config.covered_cd) {
					if (pop.type === "Secondary") {
						this.markersPcn.push(
							this.mapService.popToMarker(pop, config.icons.pcn_standard, config.icons.pcn_smaller)
						)
					}
				}
				if (config.covered_agf) {
					if (pop.type === "AGF") {
						this.markersPopAgf.push(
							this.mapService.popToMarker(
								pop,
								config.icons.pop_agf_standard,
								config.icons.pop_agf_smaller
							)
						)
					}
				}

				// if (config.covered_ab && !config.covered_cd) {
				//   if (pop.type !== 'Secondary' && pop.type !== 'AGF') {
				//     this.markersPops.push(this.mapService.popToMarker(pop, config.icons.pop_standard, config.icons.pop_smaller));
				//   }
				// } else if (!config.covered_ab && config.covered_cd) {
				//   if (pop.type === 'Secondary') {
				//     this.markersPcn.push(this.mapService.popToMarker(pop, config.icons.pcn_standard, config.icons.pcn_smaller));
				//   }
				// } else if (config.covered_ab && config.covered_cd) {
				//   if (pop.type === 'Secondary') {
				//     this.markersPcn.push(this.mapService.popToMarker(pop, config.icons.pcn_standard, config.icons.pcn_smaller));
				//   }
				//   if (pop.type !== 'Secondary') {
				//     this.markersPops.push(this.mapService.popToMarker(pop, config.icons.pop_standard, config.icons.pop_smaller));
				//   }
				// }

				if (pop.show) {
					this.popsAutocompleteList.push(pop)
				}
			}
			this.setMapButton("pops")
		})
	}
	// Init end

	public onSelectedAddress(place) {
		this.wait = true
		this.mapService.open("loaderModal")
		this.isPointRequested = true
		if (!place || !place.geometry) {
			this.wait = false
			this.mapService.close("loaderModal")
			return
		}
		this.place = place
		this.isPlaceSelected = true
		this.map.zoomToCoordinates(place.geometry.location, null, false)
		const markerPlace = this.mapService.place2Marker(place, "POINT_PLACE")
		this.map.showMarkers([markerPlace], { clearTypes: this.typesMarkersPointsNTW })
		this.manageBuildingsAndClusters(this.mapService.selectedCluster, this.mapOptions.service_name)
	}

	public onSelectedId(id) {
		this.mapService.open("loaderModal")
		this.wait = true
		this.isPointRequested = true
		this.mapService
			.getBuildingById(
				id,
				this.mapService.activeButtons,
				this.mapService.selectedCluster,
				this.mapOptions.service_name
			)
			.subscribe(
				res => {
					if (res) {
						if (pageConfiguration[this.mapService.activePayload].acceptedTypes.includes(res.type)) {
							this.map.zoomToCoordinates(
								{ lat: res.coordinates.coordinates[1], lng: res.coordinates.coordinates[0] },
								null,
								false
							)
							const c = this.mapService.civic2Marker(res)
							this.onSelectCivic(c, false)
							this.manageBuildingsAndClusters(
								this.mapService.selectedCluster,
								this.mapOptions.service_name,
								id
							)
						} else {
							this.wait = false
							this.errorCoverage = true
							this.isValidPoint = false
							this.mapService.close("loaderModal")
						}
					}
				},
				err => {
					this.wait = false
					this.errorCoverage = true
					this.isValidPoint = false
					this.mapService.close("loaderModal")
				}
			)
	}

	public onSelectedCity(cityObj) {
		this.isPointRequested = true
		const cityCenter = new google.maps.LatLng(cityObj.geometry.location.lat(), cityObj.geometry.location.lng())
		this.map.map.setZoom(12)
		this.map.map.setCenter(cityCenter)
	}

	public onSelectedCluster(cluster) {
		this.isPointRequested = true
		this.mapService.selectedCluster = cluster
		if (cluster === "ab") {
			this.mapService.mapButtons["pops"].active = true
			this.mapService.mapButtons["pcn"].active = false
			this.mapService.mapButtons["pop_agf"].active = false
		} else if (cluster === "cd") {
			this.mapService.mapButtons["pcn"].active = true
			this.mapService.mapButtons["pops"].active = false
			this.mapService.mapButtons["pop_agf"].active = false
		} else if (cluster === "agf") {
			this.mapService.mapButtons["pcn"].active = false
			this.mapService.mapButtons["pops"].active = false
			this.mapService.mapButtons["pop_agf"].active = true
		}
		this.setMapButton("pops")
		this.setMapButton("pcn")
		this.setMapButton("pop_agf")
	}

	public onClickBuilding(building) {
		const c = this.mapService.civic2Marker(building)
		this.onSelectCivic(c, false)
	}

	public switchSearchMode(newMode) {
		this.actualSearchMode = newMode
		if (this.actualSearchMode === "pop") {
			const zoom = this.map.map.getZoom()
			console.log(this.markersPops.length)
			console.log(this.markersPcn.length)
			console.log(this.markersPopAgf.length)

			let listPop = this.markersPops.filter(
				m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
			)
			let listPcn = this.markersPcn.filter(
				m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
			)
			let listPopAgf = this.markersPopAgf.filter(
				m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
			)
			this.map.showMarkers(listPop, { clearTypes: ["POP"] })
			this.map.showMarkers(listPcn, { clearTypes: ["PCN"] })
			this.map.showMarkers(listPopAgf, { clearTypes: ["POP_AGF"] })
			this.mapService.mapButtons.pops.active = false
			this.mapService.mapButtons.pcn.active = false
			this.mapService.mapButtons.pop_agf.active = false
			this.mapService.mapButtons.pop_all.active = true
		}
	}

	public reset() {
		this.isValidPoint = false
		this.errorCoverage = false
		this.isPointRequested = false
		this.map.removeMarkersByTypes(this.typesMarkersPointsNTW)
		this.map.removeMarkerByIcon("civic_marker_dark_blue")
		this.point = null
		this.searchPlace.reset()
		this.pop = null
		this.request = {}
		// Reset buildings if filtered by cluster
		if (this.mapService.selectedCluster) {
			this.mapService.selectedCluster = null
			this.manageBuildingsAndClusters()
		}
		setTimeout(() => {
			this._changeRef.detectChanges()
		},100)
	}

	public onSelectPop(markerPop: MapMarker) {
		const latlng = new google.maps.LatLng(markerPop.coordinates.lat, markerPop.coordinates.lng)
		this.geocoder.geocode({ location: latlng }, res => {
			const cloneMarkerPop = JSON.parse(JSON.stringify(markerPop))
			cloneMarkerPop.address = `${cloneMarkerPop.label} - ${this.mapService.pointLabel(res)}`
			const info = this.mapService.pointInfo(res)
			let setIcon
			let cluster
			switch (cloneMarkerPop.area_type) {
				case "covered_ab":
					setIcon = this.configuration[this.mapService.activePayload].icons.pop_standard
					cluster = "A&B"
					break
				case "covered_cd":
					setIcon = this.configuration[this.mapService.activePayload].icons.pcn_standard
					cluster = "C&D"
					break
				case "covered_agf":
					setIcon = this.configuration[this.mapService.activePayload].icons.pop_agf_standard
					cluster = "Bando Italia 1G"
					break
			}
			cloneMarkerPop.pop_details = {
				address: info.label,
				comune: info.comune,
				via: info.street,
				civico: String(info.street_number),
				cluster,
				nome: markerPop.nome ? markerPop.nome : "",
				alias_pop: markerPop.alias_pop ? markerPop.alias_pop : ""
			}
			const latlng = new google.maps.LatLng(cloneMarkerPop.coordinates.lat, cloneMarkerPop.coordinates.lng)
			this.map.zoomToCoordinates(latlng)
			const markerPlace = this.mapService.marker2MarkerPoint(cloneMarkerPop, "POINT_PICKED", setIcon)
			this.map.showMarkers([markerPlace], { clearTypes: this.typesMarkersPointsNTW })
			this.isPointRequested = true
			this.setPoint(cloneMarkerPop)
		})
	}

	public onClickCluster(markerCluster: MapMarker) {
		const latlng = new google.maps.LatLng(markerCluster.coordinates.lat, markerCluster.coordinates.lng)
		const zoom = this.map.map.getZoom() + 1
		this.map.zoomToCoordinates(latlng, zoom, false)
	}

	private checkIfBuilding(place, buildings) {
		this.checkBuildingCoordinates(place)
		// old version:
		// const placeLat = String(place.geometry.location.lat()).substring(0, 7);
		// const placeLng = String(place.geometry.location.lng()).substring(0, 7);
		// const found =
		//   buildings.find(b => String(b.coordinates.coordinates[1]).substring(0, 7) === placeLat && String(b.coordinates.coordinates[0]).substring(0, 7) === placeLng);
		// if (!found) {
		//   this.wait = false;
		//   this.errorCoverage = true;
		//   this.isValidPoint = false;
		//   this.mapService.close('loaderModal');
		//   return;
		// }
		// if (found.building_labels && found.building_labels.length > 1) {
		// this.checkBuildingCoordinates(place);
		// } else {
		//   const markerCivic = this.mapService.civic2Marker(found);
		//   this.onSelectCivic(markerCivic, false);
		// }
	}

	private onSelectCivic(markerCivic: MapMarker, checkIfMultiple = true) {
		this.wait = true
		this.mapService.open("loaderModal")
		// si posizionano due marker: quello a goccia arancione e il pallino blu
		const markerPoint = this.mapService.marker2MarkerPoint(markerCivic, "POINT_CIVIC", ico_civic_picked)
		const markerPlace = this.mapService.marker2MarkerPoint(markerCivic, "POINT_PICKED")
		if (checkIfMultiple) {
			// let areaType;
			// switch (markerCivic.area_type) {
			//   case 'covered_ab': areaType = ['CoveredAB']; break;
			//   case 'covered_cd': areaType = ['CoveredCD']; break;
			//   case 'covered_agf': areaType = ['CoveredAGF']; break;
			//   default: areaType = ['CoveredFWA']; break;
			// }
			this.mapService
				.getBuildingByCoordinates(
					markerCivic.coordinates.lat,
					markerCivic.coordinates.lng,
					pageConfiguration[this.mapService.activePayload].acceptedTypes,
					this.mapOptions.service_name
				)
				.subscribe(res => {
					if (res.results.length > 1) {
						this.modalBuildings = res.results
						this.mapService.open("multiBuildingModal")
						this.wait = false
					} else {
						this.map.showMarkers([markerPoint, markerPlace], { clearTypes: this.typesMarkersPointsNTW })
						this.setPoint(markerPoint)
						this.wait = false
						this.mapService.close("multiBuildingModal")
					}
					this.mapService.close("loaderModal")
				})
		} else {
			this.map.showMarkers([markerPoint, markerPlace], { clearTypes: this.typesMarkersPointsNTW })
			this.setPoint(markerPoint)
			this.mapService.close("multiBuildingModal")
			this.wait = false
			this.mapService.close("loaderModal")
		}
	}

	private setPoint(marker) {
		this.isValidPoint = false
		this.errorCoverage = false
		this.point = marker
		if (marker.type === "POINT_CIVIC") {
			// REQUEST PER BUILDING
			this.request = new BuildingReq()
			this.request.address = {
				civico: marker.marker_details.civico,
				comune: marker.marker_details.comune,
				indirizzo: marker.marker_details.via,
				particella_toponomastica: marker.marker_details.particella,
				provincia: marker.marker_details.provincia,
				regione: marker.marker_details.regione
			}
			this.request.coordinate = {
				latitudine: marker.coordinates.lat,
				longitudine: marker.coordinates.lng
			}
			this.request.id_building = marker.id
			this.request.cluster_appartenenza = this.mapOptions.cluster
			this.request.identificativo_pop = marker.marker_details.afference_pop
			this.request.stato_building = marker.marker_details.status
		} else if (marker.type === "POP" || marker.type === "PCN" || marker.type === "POP_AGF") {
			// REQUEST PER POP
			this.request = new PopReq()
			this.request.address = {
				civico: marker.pop_details.civico,
				comune: marker.pop_details.comune,
				indirizzo: marker.pop_details.via
			}
			this.request.coordinate = {
				latitudine: marker.coordinates.lat,
				longitudine: marker.coordinates.lng
			}
			this.request.identificativo_pop = marker.pop_details.nome ? marker.pop_details.nome : ""
			switch (marker.type) {
				case "POP":
					this.request.cluster_appartenenza = "AB"
					break
				case "PCN":
					this.request.cluster_appartenenza = "CD"
					break
				case "POP_AGF":
					this.request.cluster_appartenenza = "AGF"
					break
			}
			this.request.alias_pop = marker.pop_details.alias_pop ? marker.pop_details.alias_pop : null
		}
		const data = {
			for: "openfiber_community",
			data: this.request
		}
		if (!environment.LOCAL) {
			this.mapService.sendMessageInterface(data)
		} else {
			console.log("send data ", data)
		}

		setTimeout(() => {
			this.isValidPoint = true
			this._changeRef.detectChanges();
		},100)
		
	}

	public manageBuildingsAndClusters(overrideCluster?, serviceName?, id?) {
		if (
			this.mapService.activePayload !== "pre_provisioning_kit" &&
			this.mapService.activePayload !== "pre_provisioning_svlan"
		) {
			this.waitCivics = true
			this.mapService.open("loaderModal")
			this.map.removeMarkersByType("cluster")
			if (this.map.map && this.map.map.getZoom() >= this.ZOOM_CLUSTER && this.map.map.getBounds()) {
				if (this.searchBuildingPlaceholdersSubscription instanceof Subscription) {
					this.searchBuildingPlaceholdersSubscription.unsubscribe()
				}
				const zoom = this.map.map.getZoom()
				const bounds = this.map.map.getBounds()
				this.searchBuildingPlaceholdersSubscription = this.mapService
					.searchBuildingPlaceholders(
						bounds,
						zoom,
						this.mapService.activeButtons,
						overrideCluster,
						serviceName
					)
					.subscribe(res => {
						const markers = []
						if (res.results) {
							if (res.cluster) {
								this.cachedCivics = []
								this.newCivics = []
								for (const cluster of res.results) {
									markers.push(this.mapService.cluster2Marker(cluster))
								}
								this.map.showMarkers(markers, { clearTypes: this.clearTypes })
								this.waitCivics = false
								this.wait = false
								this.mapService.close("loaderModal")
							} else {
								for (const civic of res.results) {
									if (!this.mapService.alreadyExists(civic, this.cachedCivics)) {
										this.cachedCivics.push(civic)
										this.newCivics.push(civic)
									}
									// }
								}
								for (const civic of this.newCivics) {
									markers.push(this.mapService.civic2Marker(civic))
								}
								if (markers.length) {
									this.map.showMarkers(markers)
								}
								if (this.isPlaceSelected && this.place) {
									this.checkIfBuilding(this.place, res.results)
									this.isPlaceSelected = false
								} else {
									this.wait = false
									this.mapService.close("loaderModal")
								}
							}
						} else {
							this.errorCoverage = true
							this.isValidPoint = false
							this.mapService.close("loaderModal")
							this.waitCivics = false
							this.wait = false
						}
						this.newCivics = []
						this.waitCivics = false
						this.mapService.close("loaderModal")
					})
			} else if (this.map.map && this.map.map.getZoom() < this.ZOOM_CLUSTER) {
				this.waitCivics = false
				this.wait = false
				this.cachedCivics = []
				this.mapService.close("loaderModal")
			}
		}
		this.wait = false
		this.mapService.close("loaderModal")
	}

	public setMapButton(type) {
		const active = this.mapService.mapButtons[type].active
		switch (type) {
			case "pops":
				if (active) {
					const zoom = this.map.map.getZoom()
					let list = this.markersPops.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					this.map.showMarkers(list, { clearTypes: ["POP"] })
					this.mapService.mapButtons.pops.active = true
					this.mapService.mapButtons.pcn.active = false
					this.mapService.mapButtons.pop_agf.active = false
					this.mapService.mapButtons.pop_all.active = false
					this.map.removeMarkersByType("PCN")
					this.map.removeMarkersByType("POP_AGF")
				} else {
					this.map.removeMarkersByType("POP")
				}
				break
			case "pcn":
				if (active) {
					const zoom = this.map.map.getZoom()
					let list = this.markersPcn.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					this.map.showMarkers(list, { clearTypes: ["PCN"] })
					this.mapService.mapButtons.pops.active = false
					this.mapService.mapButtons.pcn.active = true
					this.mapService.mapButtons.pop_agf.active = false
					this.mapService.mapButtons.pop_all.active = false
					this.map.removeMarkersByType("POP")
					this.map.removeMarkersByType("POP_AGF")
				} else {
					this.map.removeMarkersByType("PCN")
				}
				break
			case "pop_agf":
				if (active) {
					const zoom = this.map.map.getZoom()
					let list = this.markersPopAgf.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					this.map.showMarkers(list, { clearTypes: ["POP_AGF"] })
					this.mapService.mapButtons.pops.active = false
					this.mapService.mapButtons.pcn.active = false
					this.mapService.mapButtons.pop_agf.active = true
					this.mapService.mapButtons.pop_all.active = false
					this.map.removeMarkersByType("POP")
					this.map.removeMarkersByType("PCN")
				} else {
					this.map.removeMarkersByType("POP_AGF")
				}
				break
			case "pop_all":
				if (active) {
					const zoom = this.map.map.getZoom()
					let listPop = this.markersPops.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					let listPcn = this.markersPcn.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					let listPopAgf = this.markersPopAgf.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					this.map.showMarkers(listPop, { clearTypes: ["POP"] })
					this.map.showMarkers(listPcn, { clearTypes: ["PCN"] })
					this.map.showMarkers(listPopAgf, { clearTypes: ["POP_AGF"] })
					this.mapService.mapButtons.pops.active = false
					this.mapService.mapButtons.pcn.active = false
					this.mapService.mapButtons.pop_agf.active = false
				} else {
					if (!this.mapService.mapButtons.pops.active) {
						this.mapService.mapButtons.pops.active = false
						this.map.removeMarkersByType("POP")
					}
					if (!this.mapService.mapButtons.pcn.active) {
						this.mapService.mapButtons.pcn.active = false
						this.map.removeMarkersByType("PCN")
					}
					if (!this.mapService.mapButtons.pop_agf.active) {
						this.mapService.mapButtons.pop_agf.active = false
						this.map.removeMarkersByType("POP_AGF")
					}
				}
				break
			case "covered_ab":
			case "prospect":
			case "covered_cd":
			case "covered_agf":
				this.showHideBuildingsBasedOnMapButtons(type)
				break
		}
	}

	private showHideBuildingsBasedOnMapButtons(areaType) {
		console.log(areaType)
		if (this.mapService.activeButtons.length || this.mapService.selectedCluster) {
			this.manageBuildingsAndClusters(this.mapService.selectedCluster)
		} else {
			this.map.removeMarkersByAreaType(areaType)
			this.cachedCivics = []
		}
	}

	private checkBuildingCoordinates(place) {
		let markerCivic = null
		const placeLat = String(place.geometry.location.lat())
		const placeLng = String(place.geometry.location.lng())
		this.mapService
			.getBuildingByCoordinates(
				placeLat,
				placeLng,
				pageConfiguration[this.mapService.activePayload].acceptedTypes,
				this.mapOptions.service_name
			)
			.subscribe(res => {
				const buildings = res.results
				if (buildings && buildings.length === 1) {
					markerCivic = this.mapService.civic2Marker(buildings[0])
				} else if (buildings && buildings.length > 1) {
					const searchedCivic = this.mapService.pointInfo([place]).street_number
					const found = buildings.filter(b => b.indirizzo.civico === searchedCivic)[0]
					markerCivic = found ? this.mapService.civic2Marker(found) : null
				}
				const markers = []
				for (const civic of this.newCivics) {
					if (!markerCivic || markerCivic.id !== civic.id) {
						markers.push(this.mapService.civic2Marker(civic))
					}
				}
				if (markerCivic) {
					this.onSelectCivic(markerCivic, false)
				} else {
					this.wait = false
					this.errorCoverage = true
					this.isValidPoint = false
					this.mapService.close("loaderModal")
				}
				// this.wait = false;
			})
	}

	get errorPlaceholder() {
		let item = ""
		let service = ""
		let cluster = ""
		switch (this.actualSearchMode) {
			case "address":
				item = "PLACEHOLDER.ITEMS.ADDRESS"
				break
			case "id_building":
				item = "PLACEHOLDER.ITEMS.BUILDING"
				break
			case "town":
				item = "PLACEHOLDER.ITEMS.TOWN"
				break
			case "cluster":
				item = "PLACEHOLDER.ITEMS.CLUSTER"
				break
		}
		switch (this.mapOptions.service_name) {
			case "open_stream":
				service = "Open Stream"
				break
			case "open_internet":
				service = "Open Internet"
				break
			case "pre_provisioning_kit":
				service = "Pre Provisioning KIT"
				break
			case "pre_provisioning_svlan":
				service = "Pre Provisioning SVLAN"
				break
			case "gpon":
				service = "GPON"
				break
		}
		switch (this.mapOptions.cluster) {
			case "ab":
				cluster = "A&B"
				break
			case "cd":
				cluster = "C&D"
				break
		}
		item = this.mapService.instant(item)
		return this.mapService.instant("ERRORS.ITEM_NOT_ACTIVABLE", { $1: item, $2: service, $3: cluster })
	}
}
